import React, { useEffect, useState } from "react";
import {
  Box, Button, Flex, Table, Tbody, Td, Th, Thead, Tr, Text, useToast, Spinner, Badge,
  HStack, Input, Select, Heading,
} from "@chakra-ui/react";
import { getBlocklist, addOverride, removeOverride } from "../../utils/apis/agentApi";

/** Agent dispatch blocklist: auto-derived (repeated low ratings) plus manual
 *  block/allow overrides. */
const Blocklist = () => {
  const [derived, setDerived] = useState<any[]>([]);
  const [overrides, setOverrides] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [pid, setPid] = useState("");
  const [action, setAction] = useState<"block" | "allow">("block");
  const [reason, setReason] = useState("");
  const toast = useToast();

  const load = async () => {
    setLoading(true);
    const res = await getBlocklist();
    if (res.ok && res.data) { setDerived(res.data.derived || []); setOverrides(res.data.overrides || []); }
    else toast({ title: res.status === 502 ? "Agent unreachable" : "Failed to load",
      status: "error", duration: 3000, isClosable: true });
    setLoading(false);
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  const add = async () => {
    if (!pid.trim()) return;
    const res = await addOverride(pid.trim(), action, reason.trim() || undefined);
    if (res.ok) { setPid(""); setReason(""); toast({ title: "Override added", status: "success", duration: 2000 }); load(); }
    else toast({ title: "Failed", status: "error", duration: 3000 });
  };
  const remove = async (providerId: string) => {
    const res = await removeOverride(providerId);
    if (res.ok) { toast({ title: "Removed", status: "success", duration: 2000 }); load(); }
    else toast({ title: "Failed", status: "error", duration: 3000 });
  };

  return (
    <Box p={5}>
      <Flex justifyContent="space-between" mb={4}>
        <Heading size="md">Blocklist</Heading>
        <Button colorScheme="purple" backgroundColor="#88077b" onClick={load}>Refresh</Button>
      </Flex>

      <Box mb={6} p={4} borderWidth="1px" borderRadius="md" backgroundColor="admin.surface">
        <Text fontWeight="bold" mb={2}>Add a manual override</Text>
        <HStack>
          <Input placeholder="provider_id" value={pid} onChange={(e) => setPid(e.target.value)} />
          <Select w="140px" value={action} onChange={(e) => setAction(e.target.value as any)}>
            <option value="block">block</option>
            <option value="allow">allow</option>
          </Select>
          <Input placeholder="reason (optional)" value={reason} onChange={(e) => setReason(e.target.value)} />
          <Button colorScheme="purple" backgroundColor="#88077b" onClick={add} isDisabled={!pid.trim()}>Add</Button>
        </HStack>
      </Box>

      {loading ? <Spinner size="xl" /> : (
        <>
          <Heading size="sm" mb={2}>Manual overrides</Heading>
          {overrides.length === 0 ? <Text color="admin.muted" mb={6}>None.</Text> : (
            <Table variant="striped" size="sm" mb={8}>
              <Thead backgroundColor="#88077b"><Tr>
                <Th color="white">Provider</Th><Th color="white">Action</Th>
                <Th color="white">Reason</Th><Th color="white">When</Th><Th color="white"></Th>
              </Tr></Thead>
              <Tbody>
                {overrides.map((o, i) => (
                  <Tr key={o.provider_id} backgroundColor={i % 2 === 0 ? "admin.surface" : "admin.selected"}>
                    <Td>{o.provider_id}</Td>
                    <Td><Badge colorScheme={o.action === "block" ? "red" : "green"}>{o.action}</Badge></Td>
                    <Td>{o.reason || "-"}</Td>
                    <Td>{o.created_at ? new Date(o.created_at).toLocaleDateString() : "-"}</Td>
                    <Td><Button size="xs" colorScheme="red" onClick={() => remove(o.provider_id)}>Remove</Button></Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}

          <Heading size="sm" mb={2}>Auto-derived (repeated low ratings)</Heading>
          {derived.length === 0 ? <Text color="admin.muted">None.</Text> : (
            <Table variant="striped" size="sm">
              <Thead backgroundColor="#88077b"><Tr>
                <Th color="white">Provider</Th><Th color="white">Name</Th>
              </Tr></Thead>
              <Tbody>
                {derived.map((d, i) => (
                  <Tr key={d.provider_id} backgroundColor={i % 2 === 0 ? "admin.surface" : "admin.selected"}>
                    <Td>{d.provider_id}</Td><Td>{d.worker_name || "-"}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </>
      )}
    </Box>
  );
};
export default Blocklist;
